import { ComponentType } from "react";
import { Redirect, Route, RouteComponentProps, RouteProps } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userRolesState } from "../../State/user.Atom";
import { toast } from "react-toastify";

interface IProps extends RouteProps {
    component: ComponentType<RouteComponentProps<any>> | ComponentType<any>;
    roles?: string[];
}

export function PrivateRoute({ component: Component, roles, ...rest }: IProps) {
    const userRoles = useRecoilValue(userRolesState);
    return (
        <Route
            {...rest} render={props => {
                if (!userRoles) {
                    return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
                }
                if (roles && !roles?.some(r => userRoles?.includes(r))) {
                    toast.error("You are not authorized to access this page");
                    return <Redirect to={{ pathname: "/home" }} />
                }
                return <Component {...props} />
            }
            }
        />
    );
}